/* eslint-disable no-unused-vars */
// 스테이킹 풀 상태
export enum STAKING_POOL_STATE {
  WAITING, // 0 대기: 풀만 생성된 상태 (다음 상태: 모금)
  FUNDRAIS_ING, // 1 모금 진행: stake 가능 (다음 상태: 운영 or 모금 잠김 or 모금 중지 or 모금 실패)
  FUNDRAIS_ING_LOCKED, // 2 모금 잠김 (다음 상태: 운영)
  FUNDRAIS_ING_STOPPED, // 3 모금 중지
  FUNDRAIS_ING_FAILED, // 4 모금 실패
  OPERATING, // 5 운영: 리워드 받기 가능 (다음 상태: 운영 종료 or 운영 중지)
  OPERATING_CLOSED, // 6 운영 종료
  OPERATING_STOPPED, // 7 운영 중지
  BLANK, // 8 기타(컨트랙트에 없음) WAITING날짜와 FUNDRAIS_ING 날짜 중간에 빈 날짜
}

export enum STAKING_REWARD_STATE {
  WAITING,
  ING,
  END_SUCCESS,
  END_FAIL,
}

export enum STAKING_USER_STATE {
  STAKING, // 0 스테이킹
  UNSTAKING, // 1 언스테이킹
  WITHDRAW, // 2 회수 (스테이킹 - 언스테이킹 = 0일 때 성립)
  REWARD, //3 리워드 ※ 주의 db테이블이 분리되어 있다.
  ETC, // 타입이 하나 더 있을 거 같아서 추가
}